import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "wpcm-row wpcm-justify-content-center" }
const _hoisted_3 = { class: "wpcm-col-sm-12" }
const _hoisted_4 = {
  key: 0,
  class: "el-custom-select mt-5"
}
const _hoisted_5 = { class: "donation-amount-box my-5" }
const _hoisted_6 = {
  key: 0,
  class: "custom-donation-amount wpcm-d-inline-block"
}
const _hoisted_7 = {
  key: 1,
  class: "custom-donation-amount wpcm-d-inline-block"
}
const _hoisted_8 = { class: "donation-amount-list" }
const _hoisted_9 = {
  key: 0,
  class: "cause7-pre-defind-amt"
}
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "donation_dropdowns"),
        ($props.show_currency_dropdown && $props.currencies)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_select, {
                class: "w-100",
                value: $setup.store.currency,
                onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.setValue('currency', $event))),
                placeholder: "Select Currency"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.currencies, (curr, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      value: key,
                      key: key,
                      label: curr
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(curr), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["value"])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_5, [
          ($props.custom_amount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString($setup.getSymbol()), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.store.amount) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.store.amount]
                ])
              ]))
            : (!$props.custom_amount && $props.display_amount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString($setup.getSymbol()), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString($props.display_amount), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_8, [
            ($props.show_amounts && $props.amounts)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.amounts, (amnt) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: amnt,
                      onClick: _withModifiers(($event: any) => ($setup.store.amount = $setup.convert(amnt)), ["prevent"])
                    }, [
                      _createElementVNode("a", {
                        href: "#",
                        class: _normalizeClass([
                                    'wpdonation-button',
                                    $setup.store.amount == amnt && 'active'
                                ])
                      }, _toDisplayString($setup.getSymbol()) + _toDisplayString($setup.convert(amnt)), 3 /* TEXT, CLASS */)
                    ], 8 /* PROPS */, _hoisted_10))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ]))
}